import React from "react";
import ChatBot from "../components/ChatBot";

const AIChatBot = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0b0f19 0%, #111827 50%, #030712 100%)",
        padding: "30px 20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ChatBot />
    </div>
  );
};

export default AIChatBot;